const toggleSelected = (elements, selected) => {
	Array.prototype.slice.call(elements).forEach((item) => {
		const { id } = item.dataset;

		if (id === selected) {
			item.classList.add('is-active');
		} else {
			item.classList.remove('is-active');
		}
	});
};

const scrollToMenu = (menu) => {
	window.scrollBy(0, menu.getBoundingClientRect().top - 50);
};

const getSupportedHashes = (tabs) =>
	Array.prototype.slice.call(tabs).map((tab) => tab.getAttribute('data-id'));

const isHashValid = (supportedHashed, hash) => !!~supportedHashed.indexOf(hash);

const initSectionTabmenu = () => {
	if (!document.querySelector('.about-ssp')) {
		return;
	}

	const navWrapper = document.querySelector('.HP-tabNav');
	const navElements = document.querySelectorAll('.HP-tabNav-item');
	const contentElements = document.querySelectorAll('.HP-tabNav-content');
	const initHash = window.location.hash.substr(1);
	const supportedHashed = getSupportedHashes(navElements);

	if (initHash && isHashValid(supportedHashed, initHash)) {
		toggleSelected(navElements, initHash);
		toggleSelected(contentElements, initHash);
	}

	window.addEventListener('hashchange', () => {
		const selectedId = window.location.hash.slice(1);

		if (!isHashValid(supportedHashed, selectedId)) {
			return;
		}

		toggleSelected(navElements, selectedId);
		toggleSelected(contentElements, selectedId);
		scrollToMenu(navWrapper);
	});
};

export default initSectionTabmenu;
